import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import ViewContext from '@modules/order/contexts/view-context'
import React, { FC, useContext } from 'react'
import get from 'lodash/result'
import { productPriceStore, nav } from '@stores'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import { getEnumValue } from '@utils/get-enum-value'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import HierarchyCell from '../../components/HierarchyCell'
import Typography from '@components/std-components/Typography'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'

const GenericFieldCurrencyComponent: FC<CellItem> = ({ rowData, column }) => {
  const {
    uiStore: { getHierarchy }
  } = useContext(ViewContext)
  const {
    queryParams: { clientType }
  } = nav
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const priceData = productPriceStore.getPriceForProduct(rowData?.id)
  const hierarchy = rowData?.name && getHierarchy(rowData?.name)
  const val = get(hierarchy?.[hierarchy?.length - 1], column?.field)
  const currency =
    clientType === getEnumValue(VIPClientType.Internal)
      ? priceData.rtlCurrency
      : priceData.whlCurrency
  return (
    <HierarchyCell>
      <Typography variant='subHeading1'>
        {val
          ? formatCurrencyValueByLocale(
              priceData.kpiCurrency ? priceData.kpiCurrency : currency,
              Number(val)
            )
          : 0}
      </Typography>
    </HierarchyCell>
  )
}

export default GenericFieldCurrencyComponent
